module.exports = __webpack_public_path__ + "fonts/OpenSans700.75228e27.woff";